module.exports = __webpack_public_path__ + "static/media/new-domain-es.b6828938.webp";